import { c as _c } from "react/compiler-runtime";
import { formatCurrency } from "@/libs/utils";
import { StyledHotelDetails, StyledHotelImage, StyledHotelPrice, StyledHotelRow, StyledHotelSlide, StyledStar, TitleH2, TitleH3 } from "@/styles/hotel-slide";
import Image from "next/image";
const HotelSlide = t0 => {
  const $ = _c(63);
  const {
    slide
  } = t0;
  const placement = slide.attributes.text_placement.value;
  const t1 = slide.orientation;
  const t2 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
  const t3 = placement == 0;
  let t4;
  if ($[0] !== slide.attributes.location || $[1] !== slide.orientation) {
    t4 = <TitleH2 $orientation={slide.orientation}>{slide.attributes.location}</TitleH2>;
    $[0] = slide.attributes.location;
    $[1] = slide.orientation;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = slide.attributes.has_shade_title ? slide.attributes.shade_color_title : undefined;
  let t6;
  if ($[3] !== slide.attributes.title || $[4] !== slide.attributes.title_color || $[5] !== slide.orientation || $[6] !== t5) {
    t6 = <TitleH3 $orientation={slide.orientation} $shade={t5} $color={slide.attributes.title_color}>{slide.attributes.title}</TitleH3>;
    $[3] = slide.attributes.title;
    $[4] = slide.attributes.title_color;
    $[5] = slide.orientation;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `url(https://www.alexandria.cz/${slide.attributes.image})`;
  const t8 = `${slide.attributes.background_offset_x ?? "50%"} ${slide.attributes.background_offset_Y ?? "50%"}`;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <StyledHotelImage style={{
      backgroundImage: t7,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: t8
    }} />;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = Math.floor(slide.attributes.category);
  let t11;
  if ($[11] !== t10) {
    t11 = new Array(t10).fill(0).map(_temp);
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== slide.attributes.category) {
    t12 = Math.floor(slide.attributes.category) != Math.ceil(slide.attributes.category) && <StyledStar><Image src="/star-half.svg" alt="star" fill={true} /></StyledStar>;
    $[13] = slide.attributes.category;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t11 || $[16] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== slide.attributes.tour_id.label) {
    let t15;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = / (Alexandria Club)/;
      $[20] = t15;
    } else {
      t15 = $[20];
    }
    t14 = slide.attributes.tour_id.label.replace(t15, "<br />$1");
    $[18] = slide.attributes.tour_id.label;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[21] !== t14) {
    t15 = <h3 dangerouslySetInnerHTML={{
      __html: t14
    }} />;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = slide.attributes.has_shade_row_1 ? slide.attributes.shade_color_row_1 : undefined;
  let t17;
  if ($[23] !== slide.attributes.row_1 || $[24] !== slide.attributes.row_1_color || $[25] !== slide.orientation || $[26] !== t16) {
    t17 = <StyledHotelRow $orientation={slide.orientation} $shade={t16} $color={slide.attributes.row_1_color}>{slide.attributes.row_1}</StyledHotelRow>;
    $[23] = slide.attributes.row_1;
    $[24] = slide.attributes.row_1_color;
    $[25] = slide.orientation;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const t18 = slide.attributes.has_shade_row_2 ? slide.attributes.shade_color_row_2 : undefined;
  let t19;
  if ($[28] !== slide.attributes.row_2 || $[29] !== slide.attributes.row_2_color || $[30] !== slide.orientation || $[31] !== t18) {
    t19 = <StyledHotelRow $orientation={slide.orientation} $shade={t18} $color={slide.attributes.row_2_color}>{slide.attributes.row_2}</StyledHotelRow>;
    $[28] = slide.attributes.row_2;
    $[29] = slide.attributes.row_2_color;
    $[30] = slide.orientation;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const t20 = slide.attributes.has_shade_row_3 ? slide.attributes.shade_color_row_3 : undefined;
  let t21;
  if ($[33] !== slide.attributes.row_3 || $[34] !== slide.attributes.row_3_color || $[35] !== slide.orientation || $[36] !== t20) {
    t21 = <StyledHotelRow $orientation={slide.orientation} $shade={t20} $color={slide.attributes.row_3_color}>{slide.attributes.row_3}</StyledHotelRow>;
    $[33] = slide.attributes.row_3;
    $[34] = slide.attributes.row_3_color;
    $[35] = slide.orientation;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t13 || $[39] !== t15 || $[40] !== t17 || $[41] !== t19 || $[42] !== t21) {
    t22 = <StyledHotelDetails>{t13}{t15}{t17}{t19}{t21}</StyledHotelDetails>;
    $[38] = t13;
    $[39] = t15;
    $[40] = t17;
    $[41] = t19;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t22 || $[45] !== t4 || $[46] !== t6 || $[47] !== t9) {
    t23 = <div>{t4}{t6}{t9}{t22}</div>;
    $[44] = t22;
    $[45] = t4;
    $[46] = t6;
    $[47] = t9;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  const t24 = slide.orientation;
  const t25 = placement == 0;
  let t26;
  if ($[49] !== slide.attributes.price) {
    t26 = formatCurrency(slide.attributes.price);
    $[49] = slide.attributes.price;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t26) {
    t27 = <span>od {t26}</span>;
    $[51] = t26;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== slide.orientation || $[54] !== t25 || $[55] !== t27) {
    t28 = <StyledHotelPrice $orientation={t24} $top={t25}>{t27}</StyledHotelPrice>;
    $[53] = slide.orientation;
    $[54] = t25;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== slide.orientation || $[58] !== t2 || $[59] !== t23 || $[60] !== t28 || $[61] !== t3) {
    t29 = <StyledHotelSlide $orientation={t1} $url={t2} $top={t3}>{t23}{t28}</StyledHotelSlide>;
    $[57] = slide.orientation;
    $[58] = t2;
    $[59] = t23;
    $[60] = t28;
    $[61] = t3;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  return t29;
};
export default HotelSlide;
function _temp(_, index) {
  return <StyledStar key={index}><Image src="/star.svg" alt="star" fill={true} key={index} /></StyledStar>;
}